import React, { useRef, useContext, useState, useCallback } from 'react';
import ReactDOM from 'react-dom';
import { useTranslation } from 'react-i18next';
import { Dropdown, Menu, Icon, message, Tooltip } from 'antd';
import { Container, PreviewButton, PreviewIframe, PreviewModeDiv } from './styles';
import { TEMPLATE_PREVIEW_MODAL } from '../../ComplexDocumentDesign/MenuBar/translationValues';
import { CONTEXT_KEYS, useArtboardContext } from '../../../context/complexArtboardContext';
import { useDocumentContext } from '../../../context/complexDocumentContext';
import { BusinessLogic } from '../../../context/businessLogicContext';
import { DownloadButton } from '../../ComplexDocumentDesign/MenuBar/styles';
import { DownloadButton as CustomDownloadButton } from '../../ComplexDocumentDesign/styles';
import { VARIABLE_TYPE, ALL_VARIABLE_OBJECT_TYPES } from '../../../utils/constants/appConstants';
import { generatePDFPayload } from '../../ComplexDocumentDesign/complexDocumentHelper';
import { getPreviewForDesign } from '../../../utils/services/complexEmailAPI';
import { COMPLEX_EMAIL_PREVIEW_SETTINGS } from '../translationValues';
import { PreviewLoader } from '../../ComplexDocumentDesign/complexVariables/ComplexVariablesList';
import { handleDataValidationErrors } from '../../../utils/dataValidationHelper';
import { DOCUMENT_PREVIEW_ERROR_CODES } from '../../../utils/complexDocumentConstants';
import AccessibilityPreview from '../../ComplexDocumentDesign/complexVariables/AccessibilityPreview';
import { COMPLEX_EMAIL_CONTEXT_KEYS, useEmailContext } from '../../../context/complexEmailContext';

const NAMESPACES = ['TEMPLATE_PREVIEW_MODAL', 'COMPLEX_EMAIL_PREVIEW_SETTINGS'];

const ComplexEmailPreview = props => {
  const { isVariablesTab, sampleDatas, documentVariables, globalVariables, documentStyleContextRef, setErrorMessages } = props;
  const { t } = useTranslation(NAMESPACES);
  const containerRef = useRef(null);
  const [existingDocument, setExistingDocument] = useState(undefined);
  const [loading, setLoading] = useState(false);
  const [currentView, setCurrentView] = useState(2);
  const [accessibilityPreview, setAccessibilityPreview] = useState(0);

  const getCurrentDesign = useCallback(store => store[CONTEXT_KEYS.CURRENT_DESIGN], []);
  const [currentDesign, updateArtboard] = useArtboardContext(getCurrentDesign);

  const allSelector = useCallback(store => store, []);
  const [documentContext] = useDocumentContext(allSelector, 'ComplexEmailPreview');

  const subjectSelector = useCallback(store => store[COMPLEX_EMAIL_CONTEXT_KEYS.EMAIL_SUBJECT], []);
  const [subject] = useEmailContext(subjectSelector, 'ComplexEmailSubjectEditor');

  const artboardVersionSelector = useCallback(store => store[CONTEXT_KEYS.ARTBOARD_VERSION], []);
  const [artboardVersion] = useArtboardContext(artboardVersionSelector, `ComplexEmailPreview`);

  const readonlySelector = useCallback(store => store[CONTEXT_KEYS.READONLY_TEMPLATE], []);
  const [readOnly] = useArtboardContext(readonlySelector, `ComplexEmailPreview`);

  const blocksNotFit = document.getElementsByClassName('block-not-fit');
  const isDisablePreview = blocksNotFit.length > 0;

  const { businessLogics } = useContext(BusinessLogic);

  const switchView = useCallback((e) => {
    const viewType = parseInt(e.target.id.replaceAll('viewType-', ''));
    console.log({ viewType });
    setCurrentView(viewType);
  }, []);

  const updatePreviewMode = useCallback(() => {
    if(accessibilityPreview > 0) {
      setAccessibilityPreview(0);
      updateArtboard({ [CONTEXT_KEYS.ENABLED_ACCESSIBILITY_PREVIEW]: false });
    }
    updateArtboard({ [CONTEXT_KEYS.IS_PREVIEW]: true });
    setLoading(true);
    setErrorMessages({});
    (async () => {
      let dataSet = {};
      const generateDataSet = (variable, parentDataSet = {}, sampleData = {}) => {
        if (variable.type === VARIABLE_TYPE.OBJECT || variable.type === VARIABLE_TYPE.TABLE_OBJECT) {
          let isArray = variable.name.split('.').length > 1 ? (variable.isArray || false) : true;
          let listArray = [];
          let d = sampleData?.value?.forEach(eachBlock => {
            let blockSamples = {};
            eachBlock.value.forEach(block => {
              if (block.type === VARIABLE_TYPE.CHART_OBJECT) {
                blockSamples[block.name] = block.value.source;
              } else if (block.type === VARIABLE_TYPE.TABLE_OBJECT) {
                console.log("generateDataSet coming here :: ", block.value);
                blockSamples = generateDataSet(variable.variables.find(v => v.placeHolderText === block.name), blockSamples, block.value);
                console.log("generateDataSet coming here 2 :: ", blockSamples);
              } else {
                blockSamples[block.name] = block.value;
              }
            });
            listArray.push(blockSamples);
          });
          parentDataSet = {
            ...parentDataSet,
            [variable.placeHolderText]: isArray ? listArray : listArray[0],
          };
        } else if (variable.type === VARIABLE_TYPE.CHART_OBJECT) {
          const listArray = [];
          sampleData &&
          sampleData.value &&
          sampleData.value.forEach(eachBlock => {
            let blockSamples = {};
            eachBlock.value.forEach(block => {
              blockSamples[block.name] = block.value.source;
            });
            listArray.push(blockSamples);
          });
          parentDataSet = {
            ...parentDataSet,
            ...listArray[0],
          };
        } else {
          parentDataSet = {
            ...parentDataSet,
            [variable.placeHolderText]: sampleData?.value || '',
          };
        }
        return parentDataSet;
      }
      dataSet = {
        ...dataSet,
        uniq_id:'',
        uniq_name:''
      };
      documentVariables.forEach(variable => {
        const key = ALL_VARIABLE_OBJECT_TYPES.includes(variable.type) ? variable.name : variable.placeHolderText;
        dataSet = generateDataSet(variable, dataSet, sampleDatas[key]);
      });
      const payload = generatePDFPayload(globalVariables, documentContext, businessLogics, documentStyleContextRef.current, 'flow');
      payload.dataSet = dataSet;
      payload.documentDTO.flows[0].style.height = 1123; // TODO : check hardcoded value is needed?
      payload.documentDTO.id = payload.documentDTO.documentId;
      delete payload.documentDTO.documentId;
      delete payload.documentDTO.documentName;

    if (currentDesign !== 'document') {
      payload.documentDTO.flows[0].blocks = payload.documentDTO.flows[0].blocks.map(block => {
        block.isStandalone = false;
        return block;
      })
    }
    try {
      const response = await getPreviewForDesign(payload.documentDTO.id, payload);
      if (response?.status !== 200) {
        if ( response?.data && response?.data?.errors?.[0]?.code === 5604) {
          const originalKey = response?.data?.errors?.[0]?.variable;
          const normalizedKey = originalKey?.replace(/^\[|\]$/g, '');
          const obj = { [normalizedKey]: { invalidImgId: true } };
          setErrorMessages(obj);
            message.error(
            t(
              TEMPLATE_PREVIEW_MODAL.ERROR_GENERATING_PREVIEW.key,
              TEMPLATE_PREVIEW_MODAL.ERROR_GENERATING_PREVIEW.value,
            ),
          );
          return;
        }
        else if (!DOCUMENT_PREVIEW_ERROR_CODES.includes(response?.data?.data?.errors?.[0]?.code)) {
          message.error(
            t(
              TEMPLATE_PREVIEW_MODAL.ERROR_GENERATING_PREVIEW.key,
              TEMPLATE_PREVIEW_MODAL.ERROR_GENERATING_PREVIEW.value,
            ),
          );
        }
        setErrorMessages(handleDataValidationErrors(response.data));
        setExistingDocument('');
      }
      if (response.status === 200) {
        setExistingDocument(response.data);
      }
    } catch (e) {
      message.error(
        t(
          TEMPLATE_PREVIEW_MODAL.ERROR_GENERATING_PREVIEW.key,
          TEMPLATE_PREVIEW_MODAL.ERROR_GENERATING_PREVIEW.value,
        ),
      );
    } finally {
      setLoading(false);
    }
    })();
  }, [accessibilityPreview, sampleDatas, documentVariables, globalVariables, businessLogics, documentContext]);

  const previewPortalContainerId = readOnly ? `preview-portal-${artboardVersion}` : 'preview-portal';

  return (
    <Container ref={containerRef}>
      {isVariablesTab ? (
        <CustomDownloadButton id={'more-options-download'} className="preview" onClick={updatePreviewMode} disabled={isDisablePreview}>
          <Icon type="eye" theme="filled" style={{ padding: '10px 10px 10px 0'  }} />
          {t(
            TEMPLATE_PREVIEW_MODAL.PREVIEW_DOCUMENT_BUTTON.key,
            TEMPLATE_PREVIEW_MODAL.PREVIEW_DOCUMENT_BUTTON.value,
          )}
          <Dropdown
            overlay={
              <Menu mode="vertical">
                <Menu.ItemGroup>
                <Menu.Item
                  key="1"
                  onClick={(e) => { 
                    e.domEvent.stopPropagation();
                    setAccessibilityPreview(count => count + 1); 
                    updateArtboard({ [CONTEXT_KEYS.IS_PREVIEW]: true, [CONTEXT_KEYS.ENABLED_ACCESSIBILITY_PREVIEW]: true });
                  }}
                >
                  Accessibility preview
                </Menu.Item>
                </Menu.ItemGroup>
              </Menu>}
            placement={'bottomCenter'}
            trigger={['hover']}
            getPopupContainer={() => document.getElementById('more-options-download')}
          >
            <Icon
              type="down"
              style={{ padding: 10, paddingRight: 0 }}
              onClick={(e) => e.stopPropagation()}
            />
          </Dropdown>
        </CustomDownloadButton>
      ) : (
        <Tooltip
          placement="top"
          title={t(
            TEMPLATE_PREVIEW_MODAL.PREVIEW_TOOLTIP.key,
            TEMPLATE_PREVIEW_MODAL.PREVIEW_TOOLTIP.value,
          )}
        >
          <PreviewButton
            type="primary"
            icon="eye"
            size="large"
          ></PreviewButton>
        </Tooltip>
      )}
      {(loading || existingDocument) && document.getElementById(previewPortalContainerId) && ReactDOM.createPortal(
        <PreviewIframe style={{ position: 'relative', top: 50, height: 'calc(100vh - 150px)'}} currentView={currentView}>
          {loading && (
            <PreviewLoader containerStyle={{height: '100%'}}/>
          )}
          {!loading && existingDocument && <iframe srcDoc={existingDocument} style={{ width: '100%', height: 'calc(100vh - 150px)' }}/>}
        </PreviewIframe>
      , document.getElementById(previewPortalContainerId))}
      {accessibilityPreview > 0 && document.getElementById(previewPortalContainerId) && ReactDOM.createPortal(
        <AccessibilityPreview
          key={accessibilityPreview}
          PreviewLoader={PreviewLoader}
          documentVariables={documentVariables}
          examplValuesData={sampleDatas}
          isEmail
          emailSubject={subject}
        />, document.getElementById(previewPortalContainerId))}
      {existingDocument && !accessibilityPreview && document.getElementById('email-preview-options') && ReactDOM.createPortal(
        <PreviewModeDiv>
            <Tooltip
              placement="top"
              title={t(
                `COMPLEX_EMAIL_PREVIEW_SETTINGS:${COMPLEX_EMAIL_PREVIEW_SETTINGS.SWITCH_TO_DESKTOP_VIEW.key}`,
                COMPLEX_EMAIL_PREVIEW_SETTINGS.SWITCH_TO_DESKTOP_VIEW.value,
              )}
            >
              <DownloadButton
                id='viewType-1'
                onClick={switchView}
                type="primary"
                size="large"
                icon="desktop"
                className={currentView !== 1 ? 'inactive' : ''}
              />
            </Tooltip>
            <Tooltip
              placement="top"
              title={t(
                `COMPLEX_EMAIL_PREVIEW_SETTINGS:${COMPLEX_EMAIL_PREVIEW_SETTINGS.SWITCH_TO_TABLET_VIEW.key}`,
                COMPLEX_EMAIL_PREVIEW_SETTINGS.SWITCH_TO_TABLET_VIEW.value,
              )}
            >
              <DownloadButton
                id='viewType-2'
                onClick={switchView}
                type="primary"
                size="large"
                icon="tablet"
                className={currentView !== 2 ? 'inactive' : ''}
              />
            </Tooltip>
            <Tooltip
              placement="top"
              title={t(
                `COMPLEX_EMAIL_PREVIEW_SETTINGS:${COMPLEX_EMAIL_PREVIEW_SETTINGS.SWITCH_TO_MOBILE_VIEW.key}`,
                COMPLEX_EMAIL_PREVIEW_SETTINGS.SWITCH_TO_MOBILE_VIEW.value,
              )}
            >
              <DownloadButton
                id='viewType-3'
                type="primary"
                size="large"
                icon="mobile"
                onClick={switchView}
                className={currentView !== 3 ? 'inactive' : ''}
              />
            </Tooltip>
        </PreviewModeDiv>
      , document.getElementById('email-preview-options'))}
    </Container>
  );
};

export default ComplexEmailPreview;
